import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Box, alpha, Typography } from "@mui/material";
import { FoundToggleState } from "../../types";

interface FoundToggleProps {
    foundToggle: FoundToggleState;
    setFoundToggle: (toggle: FoundToggleState) => void;
}

export const FoundToggle = ({
    foundToggle,
    setFoundToggle,
}: FoundToggleProps) => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                px: 1.5,
                py: 1.25,
                gap: 0.75,
                borderBottom: 1,
                borderColor: "divider",
                bgcolor: "#fafbfc",
            }}
        >
            <Box
                component="button"
                onClick={() => setFoundToggle(FoundToggleState.FOUND)}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.75,
                    px: 2,
                    py: 0.875,
                    border: "1px solid",
                    borderColor:
                        foundToggle === FoundToggleState.FOUND
                            ? "transparent"
                            : "#e2e8f0",
                    borderRadius: "20px",
                    bgcolor:
                        foundToggle === FoundToggleState.FOUND
                            ? "primary.main"
                            : "background.paper",
                    color:
                        foundToggle === FoundToggleState.FOUND
                            ? "white"
                            : "#64748b",
                    cursor: "pointer",
                    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                    "&:hover": {
                        bgcolor:
                            foundToggle === FoundToggleState.FOUND
                                ? "primary.dark"
                                : alpha("#223876", 0.04),
                        borderColor:
                            foundToggle === FoundToggleState.FOUND
                                ? "transparent"
                                : alpha("#223876", 0.2),
                    },
                }}
            >
                <CheckCircleOutlineIcon sx={{ fontSize: 16 }} />
                <Typography
                    sx={{
                        fontSize: "0.8125rem",
                        fontWeight: 600,
                        letterSpacing: "0.01em",
                    }}
                >
                    Found
                </Typography>
            </Box>

            <Box
                component="button"
                onClick={() => setFoundToggle(FoundToggleState.NOT_FOUND)}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.75,
                    px: 2,
                    py: 0.875,
                    border: "1px solid",
                    borderColor:
                        foundToggle === FoundToggleState.NOT_FOUND
                            ? "transparent"
                            : "#e2e8f0",
                    borderRadius: "20px",
                    bgcolor:
                        foundToggle === FoundToggleState.NOT_FOUND
                            ? "#64748b"
                            : "background.paper",
                    color:
                        foundToggle === FoundToggleState.NOT_FOUND
                            ? "white"
                            : "#64748b",
                    cursor: "pointer",
                    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                    "&:hover": {
                        bgcolor:
                            foundToggle === FoundToggleState.NOT_FOUND
                                ? "#475569"
                                : alpha("#64748b", 0.08),
                        borderColor:
                            foundToggle === FoundToggleState.NOT_FOUND
                                ? "transparent"
                                : "#94a3b8",
                    },
                }}
            >
                <HelpOutlineIcon sx={{ fontSize: 16 }} />
                <Typography
                    sx={{
                        fontSize: "0.8125rem",
                        fontWeight: 600,
                        letterSpacing: "0.01em",
                    }}
                >
                    Not Found
                </Typography>
            </Box>
        </Box>
    );
};
